import React from "react";
import {ff, form, HorizontalLoader} from "@mc/mc-legacy";
import { FormErrors, reduxForm } from "redux-form";
import {Button, Row, Col, Label} from "reactstrap";
import "./Form.scss";
import {i18n, i18nCustom} from "../../i18n/i18n";
import {withLang} from "../../i18n/withLang";
const FormActions = form.FormActions;
const FormBody = form.FormBody;

type FormData = { oldPassword: string; newPassword: string; newPassword_repeat: string };

const validate = (data, props) => {
  const errors: FormErrors<FormData> = {};

  if (!data.oldPassword) {
    errors.oldPassword = i18n(props.lang, "Validation_fieldRequired");
  }

  if (!data.newPassword) {
    errors.newPassword = i18n(props.lang, "Validation_fieldRequired");
  }

  if (!data.newPassword_repeat) {
    errors.newPassword_repeat = i18n(props.lang, "Validation_fieldRequired");
  }

  return errors;
};

class ChangePasswordForm extends React.Component<any> {
  static formName = "changePasswordForm";

  render() {
    const { error, submitting, handleSubmit } = this.props;
    const passwordComplexityDescription = i18nCustom(this.props.lang, "password_complexity.description", false);
      return (
      <form.Form className={"form"} onSubmit={handleSubmit}>
        <FormBody>
          {error && <form.ValidationErrors error={error} />}
            <Row style={{alignItems: "baseline"}}>
                <Col xs={4} className={"text-right"}>
                    <Label for={"oldPassword"}>{i18n(this.props.lang, "ProfilePage_passwordChangeCurrentPassword")}</Label>
                </Col>
                <Col xs={8}>
                    <ff.String
                        id={"oldPassword"}
                        autoComplete={"off"}
                        className={"py-15"}
                        label={false}
                        name={"oldPassword"}
                        type={"password"}
                        required
                        disabled={submitting}
                    />
                </Col>
                <Col xs={4} className={"text-right"}>
                    <Label for={"newPassword"}>{i18n(this.props.lang, "ProfilePage_passwordChangeNewPassword")}</Label>
                </Col>
                <Col xs={8}>
                    <ff.String
                        id={"newPassword"}
                        autoComplete={"off"}
                        className={"py-15"}
                        label={false}
                        name={"newPassword"}
                        type={"password"}
                        required
                        disabled={submitting}
                    />
                </Col>
                <Col xs={4} className={"text-right"}>
                    <Label for={"newPassword_repeat"}>{i18n(this.props.lang, "ProfilePage_passwordChangeNewPassword2")}</Label>
                </Col>
                <Col xs={8}>
                    <ff.String
                        id={"newPassword_repeat"}
                        autoComplete={"off"}
                        className={"py-15"}
                        label={false}
                        name={"newPassword_repeat"}
                        type={"password"}
                        required
                        disabled={submitting}
                    />
                </Col>
            </Row>

            {passwordComplexityDescription && <p className={"mt-4"}>{passwordComplexityDescription}</p>}
        </FormBody>
          <FormActions disabled={submitting} submitButton={false}>
              <Button className={"py-15"} color={"primary"} disabled={submitting}>
                  {i18n(this.props.lang, "ProfilePage_passwordChangeDo")}
                  {submitting && <HorizontalLoader />}
              </Button>
          </FormActions>
      </form.Form>
      );
  }
}

const PassForm = reduxForm<FormData, any, any>({
    form: ChangePasswordForm.formName,
    validate,
    initialValues: {},
})(ChangePasswordForm);

export default withLang(PassForm);
